const apiURLBuilder = require('core/apiURLBuilder');
const { asyncGet, asyncPost, get: getService, post: postService } = require('services/api');
const Storage = require('utilities/storage');
const { getReferenceCodeByCountry } = require('utilities/multiLanguageHelper');

const APIGet = ({ endpoint, params }) =>
    new Promise((resolve, reject) => {
        const accessToken = Storage.cookies.get('accessToken');
        getService(
            apiURLBuilder.getURL(endpoint),
            Object.assign(params, {
                header: {
                    Authorization: `Bearer ${accessToken}`,
                },
            })
        )
            .then(response => resolve(response.body))
            .catch(error => reject(error));
    });

const APIPost = (endpoint, params) => {
    new Promise((resolve, reject) => {
        const accessToken = Storage.cookies.get('accessToken');
        postService(apiURLBuilder.getURL(endpoint), {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            ...params,
        })
            .then(response => resolve(response.body))
            .catch(error => reject(error));
    });
};

const get = (endpoint, params = {}) => {
    const paramsWithAuth = {
        ...params,
        header: {
            Authorization: `Bearer ${Storage.cookies.get('accessToken')}`,
            originCountry: getReferenceCodeByCountry().toUpperCase(),
        },
    };

    return asyncGet(apiURLBuilder.getURL(endpoint), paramsWithAuth);
};

const post = (endpoint, params = {}, extraHeader = {}) => {
    const paramsWithAuth = {
        ...params,
        header: {
            Authorization: `Bearer ${Storage.cookies.get('accessToken')}`,
            originCountry: getReferenceCodeByCountry().toUpperCase(),
            ...extraHeader,
        },
    };

    return asyncPost(apiURLBuilder.getURL(endpoint), paramsWithAuth);
};

const base64ToBlob = base64 => {
    const binary = atob(base64.split(',')[1]);
    const len = binary.length;
    const buffer = new ArrayBuffer(len);
    const view = new Uint8Array(buffer);

    for (let i = 0; i < len; i++) {
        view[i] = binary.charCodeAt(i);
    }

    return view;
};

const downloadAsFile = (blobContent, fileType, fileName) => {
    const blob = new Blob([blobContent]);
    const userAgent = navigator.userAgent;

    if (/(Edge|Trident)/i.test(navigator.appVersion)) {
        window.navigator.msSaveBlob(blob, fileName);
    } else if (userAgent.indexOf('CriOS') > -1) {
        const newWindow = window.open('/');
        newWindow.onload = () => {
            newWindow.location = URL.createObjectURL(new Blob([blobContent], { type: 'application/pdf' }));
        };
    } else {
        const link = document.createElement('a');
        link.download = fileName;
        link.href = window.URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};

export default {
    base64ToBlob,
    downloadAsFile,
    APIGet,
    APIPost,
    get,
    post,
};
